import Vue from 'vue'
import axios from 'axios'
import { extractData, ApiVersionHeader } from '@/utils'
import { userUrls } from '@/api/urls'

const options = { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
const logoutOptions = { headers: ApiVersionHeader, withCredentials: true }

export const login = (email, password) => {
  return axios.post(userUrls.login(), {
    Username: email,
    Password: password
  }, options)
}

export const logout = () => {
  return axios.post(userUrls.logout(), null, logoutOptions)
}

export const current = () => {
  return axios.get(userUrls.current(), options)
    .then(extractData)
}

export const getUser = (id) => {
  return axios.get(userUrls.getUser(id), options)
}

export default {
  login,
  logout,
  current,
  getUser
}
